
<template>
  <div style="display: none"></div>
</template>
<script>
const images = require.context("@/assets/images", true, /\.(png|jpe?g)$/);
export default {
  props: {
    patientDetails: { type: Object, required: true },
    ipData: { type: Object, required: true },
    dischargeDate: { type: String, required: true },
    dischargeTime: { type: String, required: true },
    dynamicNotes: { type: Array, default: () => [] },
    patientId: { type: [Number, String], required: true },
      printWithBill: {
    type: Boolean,
    default: false
  },
     bills: {
    type: Object, 
    default: null
  }
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return "";

      const date = new Date(dateString);
      let dd = String(date.getDate()).padStart(2, "0");
      let mm = String(date.getMonth() + 1).padStart(2, "0");
      let yyyy = date.getFullYear();

      return `${dd}-${mm}-${yyyy}`;
    },

    formatTime(timeString) {
      if (!timeString) return "";

      const [hoursStr, minutes] = timeString.split(":");
      let hours = Number(hoursStr);
      let ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12;

      return `${hours}:${minutes} ${ampm}`;
    },
    async getBase64(path) {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = path;
      return new Promise((resolve, reject) => {
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL("image/png"));
        };
        img.onerror = reject;
      });
    },
    async loadImages() {
      const companyId = this.$session.get("companyId");
      const tryImage = async (path) => {
        try {
          const url = images(path);
          return await this.getBase64(url);
        } catch (e) {
          return null;
        }
      };
      const headerBase64 =
        (await tryImage(`./company${companyId}/header.png`)) ||
        (await tryImage(`./company${companyId}/header.jpg`)) ||
        (await tryImage(`./company${companyId}/header.jpeg`));
      const watermarkBase64 =
        (await tryImage(`./company${companyId}/watermark.png`)) ||
        (await tryImage(`./company${companyId}/watermark.jpg`)) ||
        (await tryImage(`./company${companyId}/watermark.jpeg`));
      return { headerBase64, watermarkBase64 };
    },
   

buildBillTable(bills) {
  const body = [
     [
    { text: "Bill No", bold: true },
    { text: "Date", bold: true },
    { text: "Item", bold: true },
    { text: "Qty", bold: true },
    { text: "Rate", bold: true },
    { text: "Amount", bold: true },
    { text: "Tax", bold: true }
  ]
  ];

  bills.billData.forEach(bill => {
    bill.billItems.forEach(item => {
      body.push([
        bill.billNo,
        this.formatDate(bill.billDate),
        item.billItem,
        item.qty,
        item.rate,
        item.amount,
        item.taxAmount
      ]);
    });
  });

  const totalAmount = Number(bills.totalAmount || 0);
  const totalReceived = Number(bills.totalReceived || 0);
  const balance = totalAmount - totalReceived;

  return [
    {
      text: "IP BILL DETAILS",
      bold: true,
      fontSize: 14,
      alignment: "center",
      margin: [0, 10, 0, 20]
    },

    {
      table: {
        headerRows: 1,
        widths: [50, 70, "*", 30, 55, 55, 40],
        body
      },
 layout: {
    vLineWidth: function () {
      return 0;
    },
    hLineWidth: function (i, node) {
      if (i === 0) return 0;
      if (i === node.table.body.length) return 0;
      if (i === 1) return 0.8;
      return 0;
    },
    paddingTop: function () {
    return 4;   
  },

  paddingBottom: function () {
    return 4;  
  }
  },
       margin: [0, 0, 0, 15]
    },

   {
  margin: [0, 15, 0, 0],
  columns: [
    { width: "*", text: "" },   // pushes totals to right side

    {
      width: 260,
      stack: [
        {
          columns: [
            { width: 130, text: "Total Amount", },
            { width: 10, text: ":" },
            { text: totalAmount.toFixed(2) }
          ],
          margin: [0, 2, 0, 2]
        },
        {
          columns: [
            { width: 130, text: "Total Received",},
            { width: 10, text: ":" },
            { text: totalReceived.toFixed(2) }
          ],
          margin: [0, 2, 0, 2]
        },
        {
          columns: [
            { width: 130, text: "Balance Amount", },
            { width: 10, text: ":" },
            { text: balance.toFixed(2) }
          ],
          margin: [0, 4, 0, 2]
        }
      ]
    }
  ]
}

  ];
}
,


    async buildDischargeDocDefinition() {
  
      const { headerBase64, watermarkBase64 } = await this.loadImages();
const content= [
          
          {
            columns: [
              {
                stack: [
                  {
                    columns: [
                      { width: 100, text: "Patient ID", bold: true },
                      { width: 10, text: ":" },
                      { text: this.patientId },
                    ],
                    margin: [0, 1, 0, 1],
                    lineHeight: 1.2,
                  },
                  {
                    columns: [
                      { width: 100, text: "Patient Name", bold: true },
                      { width: 10, text: ":" },
                      { text: this.patientDetails.name },
                    ],
                    margin: [0, 1, 0, 1],
                    lineHeight: 1.2,
                  },
                  {
                    columns: [
                      { width: 100, text: "Age", bold: true },
                      { width: 10, text: ":" },
                      { text: this.patientDetails.age },
                    ],
                    margin: [0, 1, 0, 1],
                    lineHeight: 1.2,
                  },
                  {
                    columns: [
                      { width: 100, text: "Doctor", bold: true },
                      { width: 10, text: ":" },
                      { text: this.ipData.doctorName },
                    ],
                    margin: [0, 1, 0, 1],
                    lineHeight: 1.2,
                  },
                ],
              },
              {
                stack: [
                  {
                    columns: [
                      { width: 110, text: "IP No", bold: true },
                      { width: 10, text: ":" },
                      { text: this.ipData.ipNo },
                    ],
                    margin: [0, 1, 0, 1],
                    lineHeight: 1.2,
                  },
                  {
                    columns: [
                      { width: 110, text: "IP Date", bold: true },
                      { width: 10, text: ":" },
                       {
                  text: `${this.formatDate(this.ipData.ipDate)}  ${this.formatTime(this.ipData.ipTime)}`
                    },
                    ],
                    margin: [0, 1, 0, 1],
                    lineHeight: 1.2,
                  },
                  {
                    columns: [
                      {
                        width: 110,
                        text: "Discharge D/T",
                        bold: true,
                      },
                      { width: 10, text: ":" },
                      {
                        text: `${this.formatDate(
                          this.dischargeDate
                        )}  ${this.formatTime(this.dischargeTime)}`,
                      },
                    ],
                    margin: [0, 1, 0, 1],
                    lineHeight: 1.2,
                  },
                ],
              },
            ],
          },

          // Divider line
          {
            canvas: [
              { type: "line", x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 },
            ],
            margin: [0, 10, 0, 10],
          },
          {
            text: "Discharge Summary",
            alignment: "center",
            
            bold: true,
            decoration: "underline",
            fontSize: 14,
            margin: [0, 15, 0, 15],
          },
         {
  stack: [
    // all dynamic notes here
    ...this.dynamicNotes.map((note) => ({
      stack: [
        {
          text: note.name,
          bold: true,
          decoration: "underline",
          margin: [0, 6, 0, 10],
          keepWithNext: true
        },
        {
          text: note.value,
          margin: [0, 0, 0, 6],
          lineHeight: 1.2
        }
      ]
    })),

    // seal + signature row
    {
      columns: [
        { text: "Hospital Seal", alignment: "left", bold: true },
        { text: "Doctor’s Signature", alignment: "right", bold: true }
      ],
      margin: [0, 20, 0, 0],
      keepWithNext: true   
    }
  ]
}

        ];
        if (
  this.printWithBill &&
  this.bills &&
  this.bills.billData &&
  this.bills.billData.length > 0
) {
  content.push(
    { text: "", pageBreak: "after" },   // next page
    ...this.buildBillTable(this.bills)  // bill table blocks
  );
}
      return {
        pageSize: "A4",
        pageMargins: [30, 120, 30, 50],

        header: headerBase64
          ? { image: headerBase64, width: 600, alignment: "center" }
          : null,

        background: watermarkBase64
          ? (currentPage, pageSize) => ({
              image: watermarkBase64,
              width: 300,
              opacity: 0.08,
              absolutePosition: {
                x: (pageSize.width - 300) / 2,
                y: (pageSize.height - 300) / 2,
              },
            })
          : null,
        content
       
      };
      
        

    },
  },
};
</script>
